<template>
  <t-switch
    v-model="hiddenOnMobile"
    data-testid="hide-on-mobile"
    :label="$t('forms.hide_on_mobile')"
    :disabled="switchDisabled"
    :tooltip="$t('forms.block_controlled_by_structure')"
  ></t-switch>
</template>

<script lang="ts" setup>
  import { useMjmlStore } from "@/stores/mjmlStore";
  import { TSwitch } from "@topol/twig-ui";
  import { ref, computed, onMounted } from "vue";

  const props = defineProps({
    disabled: {
      type: Boolean,
      default: false,
    },
  });

  const controlledByParent = ref(false);

  const mjmlStore = useMjmlStore();

  const hiddenOnMobile = computed({
    get() {
      return mjmlStore.getActiveBlockAttrString("css-class") &&
        mjmlStore.getActiveBlockAttrString("css-class") == "hide_on_mobile"
        ? true
        : false;
    },
    set() {
      const css = mjmlStore.getActiveBlockAttrString("css-class");
      mjmlStore.updateBlockAttribute({
        prop: "css-class",
        value: css && css == "hide_on_mobile" ? null : "hide_on_mobile",
      });
    },
  });

  const switchDisabled = computed(() => {
    return props.disabled || controlledByParent.value;
  });

  onMounted(() => {
    const section = mjmlStore.getSelectedSection;
    if (section.attributes["css-class"]) {
      controlledByParent.value = true;
    }
  });
</script>

<style></style>
